import {
  ConversionDetails,
  ConversionLog,
  ConversionLogs,
  EventActivityItem,
  EventLogs,
  EventSearchResult,
} from '../domain';
import {
  ConversionDetailsResponse,
  ConversionLogsResponse,
  EventLogDTO,
  EventLogsResponse,
  EventSearchResultResponse,
  SearchConversionsResponse,
} from './dtos';

export const mapToConversionSearchResults = (dto: ConversionLogsResponse): ConversionLogs => {
  return {
    results: dto.results.map(mapToConversionSearchResult),
    next_page: dto.next_page,
    count: dto.count,
  };
};

export const mapToFraudSearchResults = (dto: SearchConversionsResponse): ConversionLogs => {
  return {
    results: dto.results.map(mapToConversionSearchResult),
    next_page: null,
    count: dto.results.length,
  };
};

export const mapToEventLogs = (dto: EventLogsResponse): EventLogs => {
  return {
    results: mapToEventLog(dto.events),
    next_page: dto.next_page,
    count: dto.count,
  };
};

const mapToEventLog = (dto: EventLogDTO[]): EventActivityItem[] => {
  return dto.map((event) => ({
    id: event.id,
    date: event.date,
    name: event.name,
    type: event.type,
    user_address: event.user_address,
    user_identifier: event.user_identifier,
    identifier_type: event.identifier_type,
    event_args: event.event_args,
    contract_address: event.contract_address,
    transaction_hash: event.transaction_hash,
    chain_id: event.chain_id,
    transaction_value: event.transaction_value,
    source: event.source,
    referrer: event.referrer,
  }));
};

export const mapToEventSearchResult = (dto: EventSearchResultResponse): EventSearchResult => {
  return {
    triggerExecutions: dto.trigger_executions.map((execution) => ({
      id: execution.id,
      name: execution.name,
      date: execution.date,
      status: execution.status,
      statusDetails: execution.status_details,
    })),
  };
};

const mapToConversionSearchResult = (dto: ConversionLog): ConversionLog => {
  return {
    id: dto.id,
    date: dto.date,
    conversion_name: dto.conversion_name,
    end_user_address: dto.end_user_address,
    affiliate_address: dto.affiliate_address,
    end_user_amount: dto.end_user_amount,
    affiliate_amount: dto.affiliate_amount,
    payment_currency: dto.payment_currency,
    source: dto.source,
    status: dto.status,
    error: dto.error,
    payout_status: dto.payout_status,
    payout_status_details: dto.payout_status_details,
    payout_tags: dto.payout_tags,
    unprocessed_payout_reason: dto.unprocessed_payout_reason,
    flags: dto.flags ?? [],
    is_flagged: dto.is_flagged ?? false,
  };
};

export const mapToConversionDetails = (conversionDetails: ConversionDetailsResponse): ConversionDetails => {
  return {
    events: conversionDetails.events.map((event) => ({
      type: event.type,
      date: event.date,
      metadata: event.metadata,
      args: event.args,
      name: event.name,
      user_address: event.user_address,
      evaluated_currency_address: event.evaluated_currency_address,
      evaluated_enduser_address: event.evaluated_enduser_address,
      evaluated_revenue: event.evaluated_revenue,
      evaluated_volume: event.evaluated_volume,
      trigger_name: event.trigger_name,
    })),
    payout_tier_name: conversionDetails.payout_tier_name,
  };
};
